import React from 'react'
import { Link } from 'react-router-dom'

function GetStartedButton() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <section className='receive_payments'>
                <div className='container'>
                    <div className='row  justify-content-center align-items-center'>
                        <div className='col-12 col-md-12'>
                            <div className='text-center'>
                                <h2 className='receive_payments__title'>Receive payments in any African currency, no matter where you are!</h2>
                            </div>
                            <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                                <Link to='/contact' className='btn btn__outline_primary text__dark'>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GetStartedButton